import { CompanyAPI } from '@api';

const getBPES = async (groupId) => CompanyAPI.getBPES({ group_id: groupId })
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getBPES };
